import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Cell.st.css.js';
/** Cell */
class Cell extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = { isHovered: false };
    }
    _setHover(isHovered) {
        this.setState({ isHovered });
    }
    render() {
        const { dataHook, children, disableHighlight } = this.props;
        const { isHovered } = this.state;
        return (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, {
                highlight: !disableHighlight && isHovered,
            }), onMouseEnter: () => this._setHover(true), onMouseLeave: () => this._setHover(false) }, children));
    }
}
Cell.defaultProps = {
    disableHighlight: false,
    children: null,
};
Cell.displayName = 'Cell';
Cell.propTypes = {
    dataHook: PropTypes.string,
    disableHighlight: PropTypes.bool,
    children: PropTypes.any.isRequired,
};
export default Cell;
//# sourceMappingURL=Cell.js.map